import * as types from '../actionTypes';

const initialState = {
  typicalErrors: [],
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TYPICAL_ERRORS_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_TYPICAL_ERRORS_SUCCESS:
      return {...state, loading: false, typicalErrors: action.typicalErrors, error: null};
    case types.FETCH_TYPICAL_ERRORS_FAILURE:
      return {...state, loading: false, error: action.error};
    default:
      return {...state};
  }
};

export default reducer;